/*
 * Constants set by the master bundle. These are required for some AngularJS components where ES2015 constants won't
 * work.
 */

import {BOTTOM_MESSAGES_DOM_ID} from './bottom-messages.constants';

const mod = angular.module('app.masterConstants', [])

/**
 * ID of the DOM element where FlashMessageService should attach its messages.
 */
.constant('FlashMessageElementId', BOTTOM_MESSAGES_DOM_ID);

export default mod.name;



// WEBPACK FOOTER //
// ./src/app/common/master.constants.js